import firebase from 'firebase/compat/app'
// Every service must be imported explicitly with the v9 compat SDK — the
// old v7 `import firebase from 'firebase'` root bundle silently included
// them all. These imports register each service on the firebase namespace
// GLOBALLY, so this file (imported before anything else touches firebase)
// covers every component that does `import firebase from 'firebase/compat/app'`.
// firebase/functions in particular: without it firebase.functions() is
// undefined and any httpsCallable() call fails silently with a generic
// "internal" error before the network request is even made.
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import 'firebase/compat/auth'
import 'firebase/compat/storage'
import 'firebase/compat/app-check'

// firebase init goes here
const config = {
  apiKey: 'AIzaSyD_RfZOjyIrT878HpQ_xN5vfu2tEc-HGjU',
  authDomain: 'efficient-vineyard.firebaseapp.com',
  databaseURL: 'https://efficient-vineyard.firebaseio.com',
  projectId: 'efficient-vineyard',
  storageBucket: 'efficient-vineyard.appspot.com',
  messagingSenderId: '231171307256',
  // appId registers this site as the "Every.Farm Web App" in Firebase.
  // The original config predates Firebase web-app registration entirely;
  // App Check tokens are issued per registered app, so App Check (and any
  // other app-scoped service) needs this present. Added Sept 2026.
  appId: '1:231171307256:web:6f0d7f19ce45c573faed0d'
}
firebase.initializeApp(config)

// App Check: every backend request carries proof it came from THIS app,
// attested by reCAPTCHA Enterprise (invisible to users — no challenges).
// The site key is public by design, like the apiKey above. Enforcement is
// OFF in the Firebase console while monitoring accumulates; until it's
// turned on, a failed attestation changes nothing for the user. Wrapped in
// try/catch so an App Check outage can never take down the whole app while
// enforcement is off. `true` = auto-refresh tokens for long-lived sessions.
try {
  firebase.appCheck().activate(
    new firebase.appCheck.ReCaptchaEnterpriseProvider('6LfB1KQtAAAAAOxipQ451_KvRbT1DLOxO6OqXh7z'),
    true
  )
} catch (e) {
  console.warn('App Check activation failed (non-fatal while enforcement is off):', e && e.message)
}

// firebase utils
const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()
const functions = firebase.functions()
const currentUser = auth.currentUser

// Set functions region to us-central1 (default)

// (Removed with the v9-compat upgrade: the old empty db.settings({}) call
// was a vestigial v7-era "date issue fix" and now triggers a "you are
// overriding the original host" warning on every load.)

// firebase collections
const usersCollection = db.collection('users')
const datasetsCollection = db.collection('datasets')
const farmsCollection = db.collection('farms')
const deletedFarmsCollection = db.collection('deletedFarms')
const cultivarsCollection = db.collection('cultivars')
const blocksCollection = db.collection('blocks')
const interpolationRequestsCollection = db.collection('interpolationRequests')
const notificationsCollection = db.collection('notifications')
const collectorsCollection = db.collection('collectors')
const compileRequestsCollection = db.collection('compileRequests')
const compileBlocksRequestsCollection = db.collection('compileBlocksRequests')
const editRequestsCollection = db.collection('editRequests')
const copyDatasetRequestsCollection = db.collection('copyDatasetRequests')
const foldersCollection = db.collection('folders')
const statisticsCollection = db.collection('statistics')
const tracksCollection = db.collection('tracks')
const pluginsCollection = db.collection('plugins')

export {
  db,
  storage,
  auth,
  functions,
  currentUser,
  usersCollection,
  datasetsCollection,
  deletedFarmsCollection,
  farmsCollection,
  cultivarsCollection,
  blocksCollection,
  interpolationRequestsCollection,
  notificationsCollection,
  collectorsCollection,
  compileRequestsCollection,
  compileBlocksRequestsCollection,
  editRequestsCollection,
  copyDatasetRequestsCollection,
  foldersCollection,
  statisticsCollection,
  tracksCollection,
  pluginsCollection
}
